const MAX_SIDE = 1600;
const TARGET_BYTES = 300 * 1024;

const toBlob = (canvas, q) => new Promise((res) => canvas.toBlob(res, "image/jpeg", q));

// Görüntüyü tarayıcıda küçültüp JPEG'e çevirir (~250 KB hedef).
export async function compressImage(file, maxSide = MAX_SIDE) {
  const bmp = await createImageBitmap(file);
  const scale = Math.min(1, maxSide / Math.max(bmp.width, bmp.height));
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(bmp.width * scale);
  canvas.height = Math.round(bmp.height * scale);
  const ctx = canvas.getContext("2d");
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(bmp, 0, 0, canvas.width, canvas.height);
  let q = 0.8;
  let blob = await toBlob(canvas, q);
  while (blob.size > TARGET_BYTES && q > 0.5) {
    q -= 0.1;
    blob = await toBlob(canvas, q);
  }
  if (blob.size > TARGET_BYTES && maxSide > 1000) return compressImage(file, maxSide - 400);
  return new File([blob], "cek.jpg", { type: "image/jpeg" });
}
